import React from 'react'
import { cn } from '../../lib/utils'

interface SelectionCardProps {
  children: React.ReactNode
  onClick?: () => void
  selected?: boolean
  className?: string
}

export const SelectionCard: React.FC<SelectionCardProps> = ({
  children,
  onClick,
  selected = false,
  className,
}) => {
  return (
    <div
      onClick={onClick}
      className={cn(
        'bg-white border-2 rounded-xl p-6 flex items-center gap-4 cursor-pointer transition-all duration-200 shadow-sm',
        selected
          ? 'border-[#9B775D]'
          : 'border-gray-300 hover:border-[#145F6B] hover:-translate-y-0.5',
        className
      )}
      style={selected ? { backgroundColor: 'rgb(246, 241, 237)' } : {}}
    >
      {children}
    </div>
  )
}

